import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from '../common/base/SvgIcon.vue';
import useRoomInviteControl from './useRoomInviteHooks';
import ActionSheep from '../common/base/ActionSheep.vue';
import Contacts from '../ScheduleConference/Contacts.vue';
import CopyIcon from '../common/icons/CopyIcon.vue';
import '../../directives/vTap';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  setup(__props) {

const {
  t,
  invitationFeatureDetails,
  showContacts,
  contactsConfirm,
  contacts,
  remoteEnteredUserList,
  isShowRoomShareForm,
  copyRoomIdAndRoomLink,
  displayedInviteInfoList,
  onCopy,
  sidebarName,
} = useRoomInviteControl();

function handleCloseActionSheet() {
  sidebarName.value = '';
}

return { __sfc: true,t, invitationFeatureDetails, showContacts, contactsConfirm, contacts, remoteEnteredUserList, isShowRoomShareForm, copyRoomIdAndRoomLink, displayedInviteInfoList, onCopy, sidebarName, handleCloseActionSheet, SvgIcon, ActionSheep, Contacts, CopyIcon }
}

})